<template>
  <div class="actionpanel__wrapper--compressed">
    <ValidationObserver ref="form" #default="{ invalid }">
      <div class="panel__container">
        <Panel :title="title()" size="full">
          <template v-slot:body>
            <form class="form__wrapper" @submit.prevent="createPassword">
              <div class="field__row">
                <Field :label="$t('general.choosePassword')" name="password" rules="required|min:3" type="password"
                       v-model="form.password"/>
              </div>
              <div class="field__row">
                <Field :label="$t('general.password_confirmation')" name="password_confirmation"
                       rules="required|confirmed:password"
                       type="password" v-model="form.password_confirmation"/>
              </div>
              <button class="hidden" type="submit">
                {{ $t('general.login') }}
              </button>
            </form>
          </template>
          <template v-slot:footer>
            <div class="form__footer">
              <div class="field__row flex--center">
                <span class="close">X</span>
                <router-link :to="{ name: 'auth.register' }" class="text--link">{{ $t('general.getNewAccount') }}
                </router-link>
                <button class="btn btn--dark-grey btn--right" :disabled="invalid" @click="createPassword()"
                        type="button">
                  {{ $t('general.create') }}
                </button>
              </div>
            </div>
          </template>
        </Panel>
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
import { errHandler } from '@/helpers'
import Field from '@/components/Parts/Field'
import Panel from '@/components/Parts/Panel.vue'

export default {
  components: { Panel, Field },
  mounted () {
    this.init()
  },
  data () {
    return {
      token: '',
      tokenVerified: false,
      submitted: false,
      form: {
        password: '',
        password_confirmation: '',
        token: this.$route.params.token
      },
      submit: false
    }
  },
  methods: {
    init () {
      this.tokenVerification()
    },
    title () {
      if (typeof this.$route.meta.create !== 'undefined') {
        return this.$t('general.createPasswordTitle')
      }
      return this.$t('general.resetPasswordTitle')
    },
    async tokenVerification () {
      try {
        await this.$store.dispatch('auth/resetTokenVerification', this.form.token)
          .then(() => {
            this.tokenVerified = true
          })
      } catch (e) {
        errHandler(e, this.$toasted, key => this.$t(key))
      }
    },

    async createPassword () {
      if (await this.$refs.form.validate()) {
        try {
          this.submit = true
          await this.$store.dispatch('auth/createNewPassword', this.form)
          this.submitted = true
          this.$router.replace({ name: 'auth.login', query: { sticky: 'resetPasswordSuccess' } })
        } catch (e) {
          errHandler(e, this.$toasted, key => this.$t(key))
        } finally {
          this.submit = false
        }
      }
    }
  }
}
</script>
